import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a headlights
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <HeadlightsIcon width={12} />
 */
const HeadlightsIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M6.09,19.4a1,1,0,0,1,.46-1.27L17.42,13.7a1,1,0,1,1,.81,
            1.73L7.36,19.86A1,1,0,0,1,6.09,19.4ZM7,25.48a1,1,0,0,0,
            .4-0.09L18.23,21a1,1,0,1,0-.81-1.73L6.55,23.65A1,1,0,0,0,7,
            25.48Zm10.47-.72L6.55,29.18a1,1,0,1,0,.81,1.73l10.87-4.42A1,
            1,0,1,0,17.42,24.76Zm0,5.53L6.55,34.71a1,1,0,1,0,.81,1.73L18.23,32A1,
            1,0,0,0,17.42,30.29Zm4.88-18.5A46.68,46.68,0,0,0,21.08,24,59.71,59.71,
            0,0,0,22.3,36.21S43.51,35.74,43.51,24,22.3,11.79,22.3,11.79Z`}
        />
    </SvgIcon>
)

HeadlightsIcon.defaultProps = defaultProps

export { HeadlightsIcon }
